var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgListGrayIc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C6C6CC",
    fillRule: "nonzero",
    d: "M5.5 17a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2h1.5zM20 17a1 1 0 0 1 0 2H8.645a1 1 0 0 1 0-2H20zM5.5 11a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2h1.5zM20 11a1 1 0 0 1 0 2H8.645a1 1 0 0 1 0-2H20zm0-6a1 1 0 0 1 0 2H8.645a1 1 0 1 1 0-2H20zM5.5 5a1 1 0 1 1 0 2H4a1 1 0 1 1 0-2h1.5z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListGrayIc);
export default __webpack_public_path__ + "static/media/list_gray_ic.8cc0c5b5936b8c8fba1832f41404cfe9.svg";
export { ForwardRef as ReactComponent };